export default __webpack_public_path__ + "static/media/Cafe_Francoise_F.46c95ada.woff";